import { useState } from 'react';
import type { PropsWithChildren } from 'react';
import { useGetBffUserQuery } from 'redux/services/bffUserApi';
import NotLoggedInMessage from 'components/pages/NotLoggedInMessage/NotLoggedInMessage';
import SilentLogin from 'components/util/SilentLogin/SilentLogin';
import Spinner from 'components/global/Spinner/Spinner';
import AccessDeniedPage from 'components/pages/AccessDeniedPage/AccessDeniedPage';

interface LoginHandlerProps extends PropsWithChildren {
  allowedRoles: string[];
}

function LoginHandler({ allowedRoles, children }: Readonly<LoginHandlerProps>) {
  const { data: claims, isFetching, isError, refetch } = useGetBffUserQuery();

  const hasMatchingRole = claims?.some(
    (claim) => claim.type === 'role' && allowedRoles.includes(claim.value),
  );

  const [isSilentLoginCompleted, setIsSilentLoginCompleted] = useState(false);

  const onSilentLoginCompleted = (isLoggedIn: boolean) => {
    if (isLoggedIn) {
      void refetch();
    }
    setIsSilentLoginCompleted(true);
  };

  if (claims) {
    return hasMatchingRole ? <>{children}</> : <AccessDeniedPage />;
  }

  if (isError && !isSilentLoginCompleted) {
    return (
      <>
        <Spinner size="large" />
        <SilentLogin onCompleted={onSilentLoginCompleted} />
      </>
    );
  }

  if (isFetching || !isSilentLoginCompleted) {
    return <Spinner size="large" />;
  }

  return <NotLoggedInMessage />;
}

export default LoginHandler;
